export const Demography = ({ activeTab, setActiveTab }) => {
    return (
        <div className="btn-wrapper bg-gray-200 rounded-lg p-1 flex flex-wrap gap-2">

            <button
                onClick={() => setActiveTab('countries')}
                className={`flex-1 py-2 px-4 text-sm font-bold rounded-md ${
                    activeTab === 'countries'
                        ? 'bg-theme_clr2 text-white'
                        : 'text-theme_clr1 hover:text-gray-900'
                }`}
            >
                Top Countries
            </button>

        </div>
    );
};